import { ChatLoader } from "../../../../packages/components";
import { ChatWithHeader } from "../../../../packages/components/chat-with-header";
import { useShowLoader } from "../../../../packages/hooks";
import { useSSE } from "../../../sse";
import { ChatBody } from "./chat-body";

export const ChatOpened = () => {
  useSSE();

  const { showLoader } = useShowLoader();

  const content = showLoader ? <ChatLoader /> : <ChatBody />;

  return <ChatWithHeader>{content}</ChatWithHeader>;
};
